<a app-button Lighter [routerLink]="RouterLink" [queryParams]="QueryParams" *ngIf="RouterLink"><fa-icon [icon]="Icon"></fa-icon></a>
